import React from 'react';
import BreadCrumb from '../../Components/Commons/BreadCrumb';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';

import List from './List';

const DeviceExports = ({t, i18n}) => {

    document.title = "WebService Data Replication";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("Device Exports")} pageTitle={t("Device Exports List")} />
                    <List />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withTranslation()(DeviceExports);